import { render, staticRenderFns } from "./IconTypeformMultipleChoice.vue?vue&type=template&id=559705b5&"
import script from "./IconTypeformMultipleChoice.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformMultipleChoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports